// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AlertTriangle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13">
            <path
                fill="currentColor"
                d="M13.8431929,10.5273438 L8.0107714,0.57421875 C7.56424833,-0.19140625 6.43741179,-0.19140625 5.98788047,0.57421875 L0.158193057,10.5273438 C-0.290517563,11.2902342 0.268361216,12.25 1.16772467,12.25 L12.8325686,12.25 C13.7283501,12.25 14.2888961,11.2929688 13.8431934,10.5273438 L13.8431929,10.5273438 Z M6.34280307,3.71875 C6.34280307,3.35644531 6.63674838,3.0625 6.99905307,3.0625 C7.36135775,3.0625 7.65530307,3.35781217 7.65530307,3.71875 L7.65530307,7.21875 C7.65530307,7.58105469 7.36135775,7.875 7.02366227,7.875 C6.6859668,7.875 6.34280307,7.58242154 6.34280307,7.21875 L6.34280307,3.71875 Z M6.99905307,10.5 C6.52436555,10.5 6.1393655,10.1150004 6.1393655,9.64031243 C6.1393655,9.16562533 6.52409226,8.78062487 6.99905307,8.78062487 C7.47401387,8.78062487 7.85874063,9.1656245 7.85874063,9.64031243 C7.85764665,10.114453 7.47483415,10.5 6.99905307,10.5 Z"
                transform="translate(0 .625)"
            />
        </svg>
    );
};

export default React.memo(AlertTriangle);
